export default __webpack_public_path__ + "static/media/buttons-back.fe5ba05b.svg";